  // var readMoreBtn = document.getElementById("read-more-btn");
  //       var shortDesc = document.querySelector(".description-short");
  //       var fullDesc = document.querySelector(".description-full");

  //       if (readMoreBtn && shortDesc && fullDesc) {
  //           shortDesc.style.display = "block";
  //           fullDesc.style.display = "none";

  //           readMoreBtn.addEventListener("click", function () {
  //               if (fullDesc.style.display === "none" || fullDesc.classList.contains("hidden")) {
  //                   fullDesc.style.display = "block";
  //                   fullDesc.classList.remove("hidden");
  //                   shortDesc.style.display = "none";
  //                   readMoreBtn.textContent = "Read Less";
  //               } else {
  //                   fullDesc.style.display = "none";
  //                   fullDesc.classList.add("hidden");
  //                   shortDesc.style.display = "block";
  //                   readMoreBtn.textContent = "Read More";
  //               }
  //           });
  //       } else {
  //           console.error("❌ Element(s) missing: Check if .description-short, .description-full, or #read-more-btn exists in your HTML.");
  //       }
    document.addEventListener("click", function (event) {
        var readMoreBtn = document.getElementById("read-more-btn");
        var shortDesc = document.querySelector(".description-short");
        var fullDesc = document.querySelector(".description-full");

        if (event.target && event.target.id === "read-more-btn") {
            if (fullDesc.style.display === "none" || fullDesc.classList.contains("hidden")) {
                fullDesc.style.display = "block";
                fullDesc.classList.remove("hidden");
                shortDesc.style.display = "none";
                readMoreBtn.textContent = "Read Less";
            } else {
                fullDesc.style.display = "none";
                fullDesc.classList.add("hidden");
                shortDesc.style.display = "block";
                readMoreBtn.textContent = "Read More";
            }
        }
    });